<template>
  <com-card>
      <div slot="content" class="homepage containerWrap">
          <!-- 全局搜索 -->
          <div class="search">
              <el-form status-icon label-width="100px" class="searchTop fl">
                  <div class="searchTime">
                      <el-form-item class="fl" label="开始时间:">
                          <el-date-picker v-model="startTime" type="date" placeholder="开始日期" value-format="yyyy-MM-dd">
                          </el-date-picker>
                      </el-form-item>
                      <el-form-item class="fl" label="结束时间:">
                          <el-date-picker v-model="endTime" type="date" placeholder="结束日期" value-format="yyyy-MM-dd">
                          </el-date-picker>
                      </el-form-item>
                      <el-form-item class="fl" label="学科分类:">
                          <el-select v-model="xuekefl" multiple placeholder="请选择" @change="xuekeChange">
                              <el-option v-for="item in xuekeData" :key="item.xkname" :label="item.xkname"
                                  :value="item.xkname">
                              </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item label="主题:" prop="zhuti">
                        <el-input size="small" v-model="ruleForm.zhuti" placeholder="请输入主题" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="关键词:" prop="guanjian">
                      <el-input size="small" v-model="ruleForm.guanjian" placeholder="请输入关键词" clearable></el-input>
                  </el-form-item>
                      <el-form-item class="fl" label="出版社:">
                          <el-input clearable v-model="public"> </el-input>
                      </el-form-item>
                      <el-form-item class="fl" label="征订号:">
                          <el-input clearable v-model="order"> </el-input>
                      </el-form-item>
                  </div>
                  <!-- 检索和重置按钮 -->
                  <div class="search-btn fl">
                      <el-button type="primary" size="mini" class="submit-btn" @click="WL_SalesOrderDHL">检索</el-button>
                      <el-button @click="Reset" size="mini" class="iconfont icon-reset reset-btn">重置</el-button>
                  </div>
              </el-form>
          </div>
          <!-- 表格 -->
          <div class="orderContent">
              <div class="Statistics ">
                  <span>选中:<b>{{ quantity }}</b>条，</span>
                  <span>册数:<b>{{ quantityFactvolume }}</b>，</span>
                  <span>品种:<b>{{ quantityFactvariety }}</b>，</span>
                  <span>码洋:<b>{{ Math.round(quantityFactprice * 100) / 100 }}</b>元，</span>
                  
                  <span>30天已发书码洋数:<b>{{ Math.round(quantityMypslThreety * 100) / 100 }}</b>，</span>
                  <span>45天已发书码洋数:<b>{{ Math.round(quantityMypslFourty * 100) / 100 }}</b>，</span>
                  <span>60天已发书码洋数:<b>{{ Math.round(quantityMypslSixty * 100) / 100 }}</b>，</span>
                  <span>一年已发书码洋数:<b>{{ Math.round(quantityMypslYear * 100) / 100 }}</b>，</span>

                  <span>30天已发书册数:<b>{{ quantityCspslThreety }}</b>，</span>
                  <span>45天已发书册数:<b>{{ quantityCspslFourty }}</b>，</span>
                  <span>60天已发书册数:<b>{{ quantityCspslSixty }}</b>，</span>
                  <span>一年已发书册数:<b>{{ quantityCspslYear }}</b>，</span>

                  <span>30天已发书品种数:<b>{{ quantityPzpslThreety }}</b>，</span>
                  <span>45天已发书品种数:<b>{{ quantityPzpslFourty }}</b>，</span>
                  <span>60天已发书品种数:<b>{{ quantityPzpslSixty }}</b>，</span>
                  <span>一年已发书品种数:<b>{{ quantityPzpslYear }}</b>，</span>
                  <!-- <span>已发书品种:<b>{{ quantityPzpsl }}</b>，</span>
                  <span>已发书码洋:<b>{{ Math.round(quantityMypsl * 100) / 100 }}</b>元，</span> -->
                  <span>30天综合码洋发书率:<b>{{ quantityTotalMypslThreety + '%' }}</b>，</span>
                  <span>45天综合码洋发书率:<b>{{ quantityTotalMypslFourty + '%' }}</b>，</span>
                  <span>60天综合码洋发书率:<b>{{ quantityTotalMypslSixty + '%' }}</b>，</span>
                  <span>一年综合码洋发书率:<b>{{ quantityTotalMypslYear + '%' }}</b>，</span>

                  <span>30天综合册数发书率:<b>{{ quantityTotalCspslThreety + '%' }}</b>，</span>
                  <span>45天综合册数发书率:<b>{{ quantityTotalCspslFourty + '%' }}</b>，</span>
                  <span>60天综合册数发书率:<b>{{ quantityTotalCspslSixty + '%' }}</b>，</span>
                  <span>一年综合册数发书率:<b>{{ quantityTotalCspslYear + '%' }}</b>，</span>

                  <span>30天综合品种发书率:<b>{{ quantityTotalPzpslThreety + '%' }}</b>，</span>
                  <span>45天综合品种发书率:<b>{{ quantityTotalPzpslFourty + '%' }}</b>，</span>
                  <span>60天综合品种发书率:<b>{{ quantityTotalPzpslSixty + '%' }}</b>，</span>
                  <span>一年综合品种发书率:<b>{{ quantityTotalPzpslYear + '%' }}</b>，</span>

                  <!-- <span>综合品种发书率:<b>{{ quantityTotalPzpsl + '%' }}</b>，</span>
                  <span>综合码洋发书率:<b>{{ quantityTotalMypsl + '%' }}</b></span> -->
              </div>
              <div>
                  <div class="export_all"></div>
                  <el-table :data="tableData" @select="selectChange" @select-all="selectAllChange"
                      @selection-change="selectionChangeHandler" border style="width: 100%; margin-top: 15px"
                      text-algin="center">
                      <el-table-column type="selection" width="55"></el-table-column>
                      <el-table-column prop="salesid" label="销售编号" width="150">
                      </el-table-column>
                      <el-table-column prop="factvolume" label="有效册数">
                      </el-table-column>
                      <el-table-column prop="factvariety" label="有效种数">
                      </el-table-column>
                      <el-table-column prop="factprice" label="有效码洋（元）">
                      </el-table-column>
                      <el-table-column prop="nmydsl30" label="30天码洋到书率"> </el-table-column>
                      <el-table-column prop="nmydsl45" label="45天码洋到书率"> </el-table-column>
                      <el-table-column prop="nmydsl60" label="60天码洋到书率"> </el-table-column>
                      <el-table-column prop="nmydsl365" label="一年码洋到书率"> </el-table-column>

                      <el-table-column prop="ncsdsl30" label="30天册数到书率"> </el-table-column>
                      <el-table-column prop="ncsdsl45" label="45天册数到书率"> </el-table-column>
                      <el-table-column prop="ncsdsl60" label="60天册数到书率"> </el-table-column>
                      <el-table-column prop="ncsdsl365" label="一年册数到书率"> </el-table-column>

                      <el-table-column prop="npzdsl30" label="30天品种到书率"> </el-table-column>
                      <el-table-column prop="npzdsl45" label="45天品种到书率"> </el-table-column>
                      <el-table-column prop="npzdsl60" label="60天品种到书率"> </el-table-column>
                      <el-table-column prop="npzdsl365" label="一年品种到书率"> </el-table-column>

                      <el-table-column prop="name" label="操作">
                          <template slot-scope="scope">
                              <el-link type="primary" @click="GoOrderDetails(scope.row.salesid)">查看详情</el-link>
                          </template>
                      </el-table-column>
                  </el-table>
              </div>
              <div class="">
                  <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                      :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next, jumper"
                      :total="total">
                  </el-pagination> -->
                  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" 
                  :current-page="pageNum" :page-size="pageSize" 
                  :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper"
                   :total="total"></el-pagination>
                 
                   
              </div>
          </div>
      </div>
  </com-card>
</template>

<script>
  import {
      Row,
      Col,
      Table,
      TableColumn,
      Form,
      FormItem,
      Input,
      Button,
      Notification,
      Checkbox,
      DatePicker,
      CheckboxGroup,
      Select,
      Option,
      Pagination
      // link
  } from "element-ui";
import Axios from "@/api/diyaxioscopy.js";
export default {
  name: "Contact",
  data() {
      return {
          selectTableData: [],
          tableData: [], // 渲染列表
          pageSize: 10,
          total: 100,
          pageNum: 1,
          startTime: "",//开始时间
          endTime: "",//结束时间
          xuekefl: "",//学科分类
          xuekeData: [],//学科分类
          public: "",//出版社
          order: "",//订单号
          ids: [],
          ruleForm:{
            zhuti:'',
            guanjian:'',
          }

      };
  },
  components: {
     'el-pagination':Pagination,
  },
  computed: {

  },
  mounted() {
      let vm = this;
      vm.getOrder()
      if (vm.ids.length == 0) {
          vm.ids = ""
      }
      setTimeout(() => {
          vm.WL_SalesOrderDHL()
          // vm.WL_SalesOrderDHL_count()
      }, 1000);
  },
  methods: {
      // 重置
      Reset() {
          let vm = this;
          vm.startTime = "",
          vm.endTime = "",
          vm.xuekefl = "",
          vm.public = "",
          vm.order = ""
      },
      // 获取学科分类下拉框
      getOrder() {
          let vm = this,
              url = "/sxerp/pt/erpservice/cgtbookinfo/getyijixueke"
          var obj = {
          };
          Axios.post(
              url,
            {params:obj},
              {
                  headers: {
                      "Content-Type": "application/json",
                  },
              }).then((res) => {
                  vm.xuekeData = res.data
              })
              .catch((err) => { });
      },
      // 选择学科分类
      xuekeChange(value) {
          let vm = this;
          vm.ids = value.join(",")
      },
      //数据列表
      WL_SalesOrderDHL() {
          let vm = this,
              url = "/sxerp/pt/erpservice/rsalesorder/WL_SalesOrderDHL"
              // userInfo = getUserInfo();
          if (
              vm.startTime &&
              vm.endTime &&
              new Date(vm.startTime).getTime() >=
              new Date(vm.endTime).getTime()
          ) {
              vm.$message({
                  type: "error",
                  message: "开始日期不能大于结束日期",
              });
              return;
          }
          var obj = {
              customerid: '19',
              datestart: vm.startTime,
              dateend: vm.endTime,
              InitialOrderCode: vm.order,
              c210c: vm.public,
              xkid: vm.ids,
              startindex: vm.pageNum,
              pageindex: vm.pageSize,
          };
          Axios.post(
              url,
              {params:obj},
              {
                  headers: {
                      "Content-Type": "application/json",
                  },
              }).then((res) => {
                  vm.tableData = res.data
                  vm.WL_SalesOrderDHL_count()
              })
              .catch((err) => {

              });
      },
      // 总数
      WL_SalesOrderDHL_count() {
          let vm = this,
              url = "/sxerp/pt/erpservice/rsalesorder/WL_SalesOrderDHL_count"
              // userInfo = getUserInfo();
          var obj = {
              customerid: '19',
              datestart: vm.startTime,
              dateend: vm.endTime,
              InitialOrderCode: vm.order,
              c210c: vm.public,
              xkid: vm.ids,
          };
          Axios.post(
              url,
              {params:obj},
              {
                  headers: {
                      "Content-Type": "application/json",
                  },
              }).then((res) => {
                  vm.total = res.data
              })
              .catch((err) => { });
      },
      // 跳转到详情页
      GoOrderDetails(salesid) {
          let vm = this
          vm.$router.push({ name: "OrderDetails", query: { salesid: salesid,c210c:vm.public,xkid: vm.ids} });
      },
      // 全选
      selectChange(selectRow, row) {
          let vm = this,
              index = vm.getGids(vm.selectTableData).indexOf(row.salesid);
          if (index > -1) {
              vm.selectTableData.splice(index, 1);
          } else {
              vm.selectTableData.push(row);
          }
      },
      selectAllChange(selection) {
          let vm = this;
          if (selection.length > 0) {
              //全选
              let dataGid = vm.getGids(vm.tableData);
              let cGid = vm.getGids(vm.selectTableData);
              for (var a = 0; a < dataGid.length; a++) {
                  if (cGid.indexOf(dataGid[a]) < 0) {
                      vm.selectTableData.push(vm.tableData[a]);
                  }
              }
          } else {
              //全不选
              let d = vm.tableData;
              for (var a = 0; a < d.length; a++) {
                  let i = vm.getGids(vm.selectTableData).indexOf(d[a].salesid);
                  if (i > -1) vm.selectTableData.splice(i, 1);
              }
          }
      },
      getGids(arr = []) {
          if (arr.length < 1) return [];
          let gids = [];
          for (let i = 0; i < arr.length; i++) {
              gids.push(arr[i].salesid);
          }
          return gids;
      },
      // 选择项发生变化时触发该事件
      selectionChangeHandler(arr) {
          let vm = this;
          vm.curArr = arr;
          if (arr.length == vm.pageSize) {
              vm.checked = true;
              vm.isdeterminate = false;
          } else if (arr.length == 0) {
              vm.checked = false;
              vm.isdeterminate = false;
          } else if (arr.length < vm.pageSize) {
              vm.checked = false;
              vm.isdeterminate = true;
          }
      },

      // 选择日期
      dataSearch() {
          this.getListByDay();
      },
      async initData(data) {
          //获取当前时间
          var now = new Date();
          var monthn = now.getMonth() + 1;
          var yearn = now.getFullYear();
          var dayn = now.getDate();
          this.selectDay = yearn + "-" + monthn + "-" + dayn;
          this.selectUser = parseInt(localStorage.getItem("userid"));
          this.getListByDay();
      },
      async getListByDay(data) { },
      // 分页
      handleSizeChange(val) {
          this.pageSize = val;
          this.WL_SalesOrderDHL();
          // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
          // console.log(`当前页: ${val}`);
          this.pageNum = val;
          this.WL_SalesOrderDHL();
      },
  },
  computed: {
      quantity() {
          // 商品数量
          return this.selectTableData.length;
      },

      quantityFactvolume() {
          // 商品册数
          return this.selectTableData.reduce((count, item) => {
              return count + item.factvolume;
          }, 0);
      },
      quantityFactvariety() {
          // 商品品种
          return this.selectTableData.reduce((count, item) => {
              return count + item.factvariety;
          }, 0);
      },

      quantityFactprice() {
          // 商品码洋
          return this.selectTableData.reduce((count, item) => {
              return count + item.factprice;
          }, 0);
      },


      // 已发书册数
      quantityCspslThreety() {
          // 30天已发书册数
          return this.selectTableData.reduce((count, item) => {
              return count + item.dscs30;
          }, 0);
      },
      quantityCspslFourty() {
          // 45天已发书册数
          return this.selectTableData.reduce((count, item) => {
              return count + item.dscs45;
          }, 0);
      },
      quantityCspslSixty() {
          // 60天已发书册数
          return this.selectTableData.reduce((count, item) => {
              return count + item.dscs60;
          }, 0);
      },
      quantityCspslYear() {
          // 一年已发书册数
          return this.selectTableData.reduce((count, item) => {
              return count + item.dscs365;
          }, 0);
      },

      //已发书码洋
      quantityMypslThreety() {
          // 30天已发书码洋
          return this.selectTableData.reduce((count, item) => {
              return count + item.dsmy30;
          }, 0);
      },
      quantityMypslFourty() {
          // 45天已发书码洋
          return this.selectTableData.reduce((count, item) => {
              return count + item.dsmy45;
          }, 0);
      },
      quantityMypslSixty() {
          // 60天已发书码洋
          return this.selectTableData.reduce((count, item) => {
              return count + item.dsmy60;
          }, 0);
      },
      quantityMypslYear() {
          // 一年已发书码洋
          return this.selectTableData.reduce((count, item) => {
              return count + item.dsmy365;
          }, 0);
      },


      //已发书品种
      quantityPzpslThreety() {
          // 30天已发书品种
          return this.selectTableData.reduce((count, item) => {
              return count + item.dspz30;
          }, 0);
      },
      quantityPzpslFourty() {
          // 45天已发书品种
          return this.selectTableData.reduce((count, item) => {
              return count + item.dspz45;
          }, 0);
      },
      quantityPzpslSixty() {
          // 60天已发书品种
          return this.selectTableData.reduce((count, item) => {
              return count + item.dspz60;
          }, 0);
      },
      quantityPzpslYear() {
          // 一年已发书品种
          return this.selectTableData.reduce((count, item) => {
              return count + item.dspz365;
          }, 0);
      },

      // quantityPzpsl() {
      //     // 已发书品种
      //     return this.selectTableData.reduce((count, item) => {
      //         return count + item.dspz30;
      //     }, 0);
      // },
      // quantityMypsl() {
      //     // 已发书码洋
      //     return this.selectTableData.reduce((count, item) => {
      //         return count + item.dsmy30;
      //     }, 0);
      // },

      // 综合册数发书率
      quantityTotalCspslThreety() {
          let vm = this,
              val = vm.quantityCspslThreety / vm.quantityFactvolume;
          return Math.round(val * 100)|| 0;
      },
      quantityTotalCspslFourty() {
          let vm = this,
              val = vm.quantityCspslFourty / vm.quantityFactvolume;
          return Math.round(val * 100)|| 0;
      },
      quantityTotalCspslSixty() {
          let vm = this,
              val = vm.quantityCspslSixty / vm.quantityFactvolume;
          return Math.round(val * 100)|| 0;
      },
      quantityTotalCspslYear() {
          let vm = this,
              val = vm.quantityCspslYear / vm.quantityFactvolume;
          return Math.round(val * 100)|| 0;
      },

      // 综合码洋发书率
      quantityTotalMypslThreety() {
          let vm = this,
              val = vm.quantityMypslThreety / vm.quantityFactprice;
          return Math.round(val * 100)|| 0;
      },
      quantityTotalMypslFourty() {
          let vm = this,
              val = vm.quantityMypslFourty / vm.quantityFactprice;
          return Math.round(val * 100)|| 0;
      },
      quantityTotalMypslSixty() {
          let vm = this,
              val = vm.quantityMypslSixty / vm.quantityFactprice;
          return Math.round(val * 100)|| 0;
      },
      quantityTotalMypslYear() {
          let vm = this,
              val = vm.quantityMypslYear / vm.quantityFactprice;
          return Math.round(val * 100)|| 0;
      },

      // 综合品种发书率
      quantityTotalPzpslThreety() {
          let vm = this,
              val = vm.quantityPzpslThreety / vm.quantityFactvariety;
          return Math.round(val * 100)|| 0;
      },
      quantityTotalPzpslFourty() {
          let vm = this,
              val = vm.quantityPzpslFourty / vm.quantityFactvariety;
          return Math.round(val * 100)|| 0;
      },
      quantityTotalPzpslSixty() {
          let vm = this,
              val = vm.quantityPzpslSixty / vm.quantityFactvariety;
          return Math.round(val * 100)|| 0;
      },
      quantityTotalPzpslYear() {
          let vm = this,
              val = vm.quantityPzpslYear / vm.quantityFactvariety;
          return Math.round(val * 100)|| 0;
      },

      // quantityTotalPzpsl() {
      //     // 综合品种发书率
      //     let vm = this,
      //         val = vm.quantityPzpsl / vm.quantityFactvariety;
      //     return Math.round(val * 10000) / 100 || 0;
      // },
      // quantityTotalMypsl() {
      //     // 综合码洋发书率
      //     let vm = this,
      //         val = vm.quantityMypsl / vm.quantityFactprice;
      //     return Math.round(val * 10000) / 100 || 0;
      // },
  },
};
</script>

<style lang="scss" scoped>
.homepage {
  height: 1200px;

  #content {
      width: 100%;
      margin: 0px auto 0px auto;
      position: relative;
  }

  .el-form-item {
      margin-bottom: 0;
      margin-top: 15px;

      .preservation {
          background-color: #409eff !important;
      }
  }

  .searchTop {
      height: 30px;
  }

  .el-table th.el-table__cell {
      text-align: center;
  }

  .el-table .el-table__cell {
      text-align: center;
  }

  .el-pagination {
      margin-top: 20px;
  }

  .search {
      width: 100%;
      height: 200px;
      box-sizing: border-box;

      .el-input {
          width: 200px;
      }

      .el-date-editor.el-input {
          width: 200px !important;
          margin-right: 0;
      }

      .searchTop {
          display: flex;
          flex-wrap: wrap;
          // width: 80%;
          height: 200px;
      }

      .searchTime {
          display: flex;
          flex-wrap: wrap;
          // justify-content: space-around;
      }
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
      margin-right: 40px;
  }

  .search-btn {
      width: 100%;
      height: 60px;
      text-align: center;
      padding-top: 15px;
      padding-top: 20px;

      Button {
          height: 30px;
          font-size: 14px;
          border-radius: 5px;
          background-color: white;
          border: 1px solid #ccc;
          cursor: pointer;
      }

      .submit-btn {
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;
          margin-right: 20px;
      }
  }

  .orderContent {
      .export_all {
          height: 30px;

          Button {
              width: 80px;
              height: 30px;
              font-size: 14px;
              border-radius: 5px;
              background-color: white;
              border: 1px solid #ccc;
              cursor: pointer;
          }

          .submit-btn {
              color: #fff;
              background-color: #409eff;
              border-color: #409eff;
              margin-right: 20px;
          }
      }

      // .el-button {
      //     width: 65px;
      //     height: 45px;
      //     line-height: 20px;
      //     text-align: center;
      // }
      .LoginStyle {
          width: 100%;
          height: 100%;
          position: fixed;
          left: 0;
          top: 0;
          background-color: rgba(0, 0, 0, 0.8);
          // background-color: #fff;
          z-index: 50;

          .title {
              height: 30px;
              line-height: 30px;
              display: flex;
              justify-content: space-between;
              padding: 0 20px;
              color: #8c1616;
              font-size: 18px;
              background-color: rgb(248, 248, 248);
              border-radius: 10px;

              span {
                  width: 30px;
                  height: 30px;
                  display: inline-block;
                  text-align: center;
                  cursor: pointer;
              }
          }

          .el-form {
              position: absolute;
              width: 650px;
              // height: 100%;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border: 1px solid #ffce94;
              border-radius: 10px;
              // padding: 20px;
              box-sizing: border-box;
              z-index: 99;
              background-color: white;

              .el-input {
                  width: 200px;
                  border: 1px solid #ffce94;
                  border-radius: 5px;
                  margin-bottom: 20px;
              }

              .el-input__inner {
                  border: 0;
                  background-color: white;
              }

              .el-button {
                  width: 80px;
                  background-color: orange;
                  border: 0;
                  color: white;
              }

              .el-form-item__label {
                  text-align: left;
                  color: #8c1616;
              }
          }

          .msg {
              height: 30px;
              color: #ff2626;
          }
      }

      .editTable {
          width: 100%;
          height: 100%;
          position: fixed;
          left: 0;
          top: 0;
          background-color: rgba(0, 0, 0, 0.8);
          // background-color: #fff;
          z-index: 50;

          .title {
              height: 30px;
              line-height: 30px;
              display: flex;
              justify-content: space-between;
              padding: 0 20px;
              color: #8c1616;
              font-size: 18px;
              background-color: rgb(248, 248, 248);
              border-radius: 10px;

              span {
                  width: 30px;
                  height: 30px;
                  display: inline-block;
                  text-align: center;
                  cursor: pointer;
              }
          }

          .el-form {
              position: absolute;
              width: 650px;
              // height: 100%;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border: 1px solid #ffce94;
              border-radius: 10px;
              // padding: 20px;
              box-sizing: border-box;
              z-index: 99;
              background-color: white;

              .el-input {
                  width: 200px;
                  border: 1px solid #ffce94;
                  border-radius: 5px;
                  margin-bottom: 20px;
              }

              .el-input__inner {
                  border: 0;
                  background-color: white;
              }

              .el-button {
                  width: 80px;
                  background-color: orange;
                  border: 0;
                  color: white;
              }

              .el-form-item__label {
                  text-align: left;
                  color: #8c1616;
              }
          }

          .msg {
              height: 30px;
              color: #ff2626;
          }
      }
  }

  .Statistics {
      margin-top: 30px;
      // margin-left: 0px;
      padding: 0;
      color: #409eff;
      font-size: 14px;
      span>b {
          color: #ff0000;
          font-style: normal;
          padding: 0 2px;
      }
  }
}

/* /deep/.el-table .el-table__cell {
  padding: 4px 0;
  text-align: center;
  color: #787676;
} */
</style>


// WEBPACK FOOTER //
// src/views/Xtch/wuliumanage/Bookpublishingrate.vue